ZoneAbattagesController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'PaginationService',
	'ZoneAbattagesService',
	'notification',
	'MassiaApplicationService',
	'$transitions'
];

// Du fait d'une limitation d'angularJS et de blocks.smart.table
// le controller doit être déclaré comme une fonction et non une classe
// on injecte donc directement les dépendances dans la fonction comme le veut angularJS
export default function ZoneAbattagesController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	PaginationService,
	ZoneAbattagesService,
	notification,
	MassiaApplicationService,
	$transitions
) {
	const vm = this;
	const watchers = [];

	let previousTableState;
	let selectedZoneAbattageId = undefined;
	vm.loading = false;
	vm.stateParams = $stateParams;
	vm.zoneAbattages = [];

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};

	vm.itemsByPageOptions = [20, 100, 200];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	//vm.selectZoneAbattage = selectZoneAbattage;
	vm.isZoneAbattageSelected = isZoneAbattageSelected;
	vm.loadZoneAbattages = loadZoneAbattages;
	vm.deleteZoneAbattage = deleteZoneAbattage;
	vm.getApplication = getApplication;

	function init() {
		//écouter l'event lié au changement de route
		//une fois on change l'url, et on arrive sur la page "zone-abattages.list", on désélectionne la ligne sélectionnée (s'il y en a)
		$transitions.onSuccess({}, stateChangeSuccessFunc);
		watchers.push($scope.$on('$destroy', dispose));
	}

	init();

	function stateChangeSuccessFunc(event, toState) {
		if (!$stateParams.id) {
			selectedZoneAbattageId = undefined;
		}
	}

	async function getApplication() {
		const app = MassiaApplicationService.getApplication();
		return app;
	}

	function isZoneAbattageSelected(zoneAbattage) {
		return zoneAbattage && zoneAbattage.id && selectedZoneAbattageId === zoneAbattage.id;
	}

	async function loadZoneAbattages(tableState) {
		startLoading();

		//quand on rafraîchit la grille, on revient sur "zone-abattages.list", et on ferme la vue détail d'un zoneAbattage
		//sinon, on risque d'avoir la vue détail qui est ouverte, mais la ligne n'apparaît plus dans la grille
		let str = 'zone-abattages';
		if (MassiaApplicationService.getApplication() == 'qse') {
			str += '-qse';
		}
		if ($state && $state.current && $state.current.name !== str + '.list') {
			$state.go(str + '.list');
		}

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		vm.zoneAbattages = [];

		try {
			const data = await ZoneAbattagesService.getZoneAbattages(filters, sorts, pagination);

			vm.zoneAbattages = data.items;

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function deleteZoneAbattage(zoneAbattage) {
		if (zoneAbattage /*&& zoneAbattage.canDelete*/ && zoneAbattage.id) {
			const modalInstance = ModalService.confirm({
				modalTitle: $translate.instant('ZONEABATTAGES.DELETE.TITLE', { libelle: zoneAbattage.libelle }),
				modalMsg: $translate.instant('ZONEABATTAGES.DELETE.MESSAGE'),
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async function () {
				startLoading();
				try {
					await ZoneAbattagesService.deleteZoneAbattageById(zoneAbattage.id);
					notification.success($translate.instant('ZONEABATTAGES.DELETE.SUCCESS'));

					selectedZoneAbattageId = undefined;

					loadZoneAbattages();
				} catch (ex) {
					notification.error(ex.data);
				} finally {
					stopLoading();
				}
			});
		}
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}

	function dispose() {
		watchers.forEach((x) => x());
	}
}
